import React, { useEffect /* , useState */ } from 'react';
import PropTypes from 'prop-types';
import Avatar from 'components/common/Avatar';
import Flex from 'components/common/Flex';
import { Collapse, Row } from 'react-bootstrap';
import Input from 'components/common/Input';
import { contextPayment } from 'context';

const ButonForm = ({ show, src, register, setValue, errors }) => {
 const { contract } = contextPayment();
 useEffect(() => {
  if (show)
   setValue('payment_method', {
    type: 'BANCOLOMBIA_TRANSFER',
    user_type: '', // Tipo de persona
    payment_description: contract?.project?.detail
     ? contract?.project?.detail
     : contract?.project?.name?.toLowerCase() + ' ' + contract?._id?.slice(-4), // Nombre de lo que se está pagando. Máximo 64 caracteres
    // El siguiente dato SOLO aplica si estás haciendo transacciones current Sandbox:
    sandbox_status: 'APPROVED', // Status final deseado current el Sandbox. Uno de los siguientes: APPROVED, DECLINED o ERROR
    ecommerce_url: 'http://localhost:3000'
   });
 }, [show]);

 return (
  <Collapse in={show} appear>
   <div id="example-collapse-text">
    <Flex className="fs--1 mb-3 d-block d-sm-none" alignItems="center" wrap="wrap">
     <Avatar src={src} size={'4xl'} className="me-3" />
     <div className="flex-1 ps-3 border-start border-start-dark">
      <h5 className="mb-0 text-primary">
       <span className="bg-100 dark__bg-1100 pe-3">BOTON</span>
      </h5>
      <span className="bg-100 dark__bg-1100 pe-3">App Bancolombia</span>
     </div>
    </Flex>
    <Input
     type="select"
     errors={errors}
     label="Tipo de persona"
     name={['payment_method', 'user_type']}
     placeholder="SELECCIONA EL TIPO"
     options={[
      { label: 'Persona natural', value: 'PERSON' },
      { label: 'Persona jurídica (no disponible aún)', value: 'BUSINESS', disabled: true }
     ]}
     formLabelProps={{ column: true, xs: 12, sm: 6, className: 'text-lg-end' }}
     formColumnProps={{ xs: 12, sm: 6, className: 'text-info' }}
     formGroupProps={{ as: Row, className: 'my-3' }}
     formControlProps={{ ...register('payment_method.user_type', { required: true }) }}
    />
    <span className="bg-100 dark__bg-1100 pe-3 fs--1 mt-4">
     Usa tu <strong>cuenta de ahorros o corriente</strong>, recuerda que debes tener activo el servicio de{' '}
     <strong>clave dinámica</strong> de la App Bancolombia
    </span>
   </div>
  </Collapse>
 );
};

ButonForm.propTypes = {
 show: PropTypes.bool,
 src: PropTypes.string,
 register: PropTypes.func,
 setValue: PropTypes.func,
 errors: PropTypes.object
};

export default ButonForm;
